/**
 * Kod wygenerowany automatycznie przez automatyczne narz�dzie (problemy zg�asza� do Tomasza Grze�kiewicza)
 * nie zmieniaj tego pliku, wszystkie zmiany zostan� nadpisane automatycznie
 */
import {Api} from "../index";
import {ReactivityValidator} from "../../utils/ReactivityValidator"

export const PublicContestEvaluation = {

	getFinishedCollaborationEvaluation (context, offerId, onSuccess, onError, options) {
		Api.get(context,
			"/public-contest-evaluation/finished-collaboration-evaluation"
			+ "?offerId=" + offerId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getFinishedOfferEvaluations (context, offerId, onSuccess, onError, options) {
		Api.get(context,
			"/public-contest-evaluation/finished-offer-evaluations"
			+ "?offerId=" + offerId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getOfferEvaluationPoints (context, offerId, onSuccess, onError, options) {
		Api.get(context,
			"/public-contest-evaluation/offer-evaluation-points"
			+ "?offerId=" + offerId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

};
